import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CorporateEventsBanner from "../../../../components/reusable-components/b2b/corporate-events-banner/CorporateEventsBanner";
import { CorporateEventStatusEnum, GridIdsEnum } from "../../../../constants/enums";
import CorporateEventGrid from "../CorporateEventsGrid";
import { useAppDispatch, useAppSelector } from "../../../../hooks/storeHooks";
import { getCorporateEventsThunk } from "../../../../store/b2b/corporateEvent/corporateEventThunk";
import IsMobile from "../../../../hooks/isMobile";
import { getCorporateActiveEventsListColumns } from "../../../../utils/B2B/corporateEventsUtils";
import { ROUTE_QUERY_CONSTANTS } from "../../../../routes";
import { useOnUpdateUserEvents } from "../../../../hooks/firestoreHooks/eventListUpdateHook";

const ActiveEventsRFPS = () => {
	const dispatch = useAppDispatch();
	const isMobile = IsMobile();
	const { corporateEvents } = useAppSelector((state) => state.corporateEvent);
	const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
	const columns = getCorporateActiveEventsListColumns();

	const fetchEventListData = () => {
		dispatch(getCorporateEventsThunk(CorporateEventStatusEnum.Active));
		setShouldStartUpdating(true);
	};

	useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

	useEffect(() => {
		fetchEventListData();
	}, []);

	return (
		<Box className="content">
			<CorporateEventsBanner />
			<Box
				className="pageLayout"
				sx={{
					display: "flex",
					flexDirection: isMobile ? "column-reverse" : "column",
					paddingTop: "0px !important"
				}}>
				<CorporateEventGrid
					corporateEventList={corporateEvents}
					columns={columns}
					title="Active Events (RFPS)"
					queryParams={ROUTE_QUERY_CONSTANTS.CorporateActiveEvents}
					gridId={GridIdsEnum.CORPORATE_EVENTS_ACTIVE}
				/>
			</Box>
		</Box>
	);
};

export default ActiveEventsRFPS;
